/*global angular */
/*jslint node: true */

'use strict';

var colorPicker = angular.module('msColorPicker', []);

var palettes;

colorPicker.directive('msColorPicker', ['$templateCache', function ($templateCache) {

    // +------------------------------------------------------------------------
    // |  Hilfsfunktionen
    // +------------------------------------------------------------------------
    function stylesHaveKey(subject, key) {
        return (subject && subject.hasOwnProperty(key));
    }

    function stylesToggleKey(subject, color1, color2, opacity) {

        if (subject && (subject.hasOwnProperty(color1) || subject.hasOwnProperty(color2))) {
            if (subject.hasOwnProperty(color1)) {
                delete subject[color1];
            }
            if (subject.hasOwnProperty(color2)) {
                delete subject[color2];
            }
        } else if (subject) {
            if (opacity) subject[opacity] = 100;
            subject['background-color'] = '';
            subject[color1] = '';
            subject[color2] = '';
        }
    }

    function hasGradient(subject, color1, color2) {
        return (subject && subject.hasOwnProperty(color1) && subject[color1] !== '' && subject.hasOwnProperty(color2) && subject[color2] !== '');
    }

    function intToHex(n) {
        n = parseInt(n,10);
        if (isNaN(n)) return "00";
        n = Math.max(0,Math.min(n,255));
        return "0123456789abcdef".charAt((n-n%16)/16) + "0123456789abcdef".charAt(n%16);
    }


    return {
        restrict: 'E',
        scope: {
            palettename: '=',
            subject: '=',
            label: '=',
            fieldColor: '=',
            fieldColorSecond: '=',
            fieldOpacity: '=',
            hintText: '=',
            hintColor: '='
        },
        link: function ($scope, element, attrs) {
            $scope.getColor = function (color) {

                if (color.length === 1) {
                    return {'background-color': '#' + intToHex(color[0].r) + intToHex(color[0].g) + intToHex(color[0].b)};

                } else if (color.length === 2) {
                    var hex1 = '#' + intToHex(color[0].r) + intToHex(color[0].g) + intToHex(color[0].b);
                    var hex2 = '#' + intToHex(color[1].r) + intToHex(color[1].g) + intToHex(color[1].b);
                    return {'background': 'linear-gradient(to bottom,' + hex1 + ' 0%,' + hex2 + ' 100%)'};
                }
            };

            $scope.stylesHaveKey = stylesHaveKey;
            $scope.stylesToggleKey = stylesToggleKey;
            $scope.hasGradient = hasGradient;

            if ($scope.subject[$scope.fieldOpacity] === undefined)
                $scope.subject[$scope.fieldOpacity] = 100;

            $scope.$watch('palettename', function (value) {

                // Select color palette
                if (!palettes.hasOwnProperty(value)) {
                    $scope.palette = palettes['default'];
                } else {
                    $scope.palette = palettes[value];
                }
            }, true);

            $scope.setColor = function (color) {

                if (color.length === 1) {
                    if ($scope.subject.hasOwnProperty($scope.fieldColorSecond))
                        delete $scope.subject[$scope.fieldColorSecond];
                    $scope.subject[$scope.fieldColor] = intToHex(color[0].r) + intToHex(color[0].g) + intToHex(color[0].b);

                } else if (color.length === 2) {
                    var hex1 = intToHex(color[0].r) + intToHex(color[0].g) + intToHex(color[0].b);
                    var hex2 = intToHex(color[1].r) + intToHex(color[1].g) + intToHex(color[1].b);
                    $scope.subject[$scope.fieldColor] = hex1;
                    $scope.subject[$scope.fieldColorSecond] = hex2;
                }
            };
        },
        template: $templateCache.get('lib/msColorPicker/color-picker.html')
    };
}]);

palettes = {
    "graustufen": [
        [
            {
                r: 255,
                g: 255,
                b: 255
            }
        ],
        [
            {
                r: 239,
                g: 239,
                b: 239
            }
        ],
        [
            {
                r: 223,
                g: 223,
                b: 223
            }
        ],
        [
            {
                r: 207,
                g: 207,
                b: 207
            }
        ],
        [
            {
                r: 191,
                g: 191,
                b: 191
            }
        ],
        [
            {
                r: 175,
                g: 175,
                b: 175
            }
        ],
        [
            {
                r: 159,
                g: 159,
                b: 159
            }
        ],
        [
            {
                r: 143,
                g: 143,
                b: 143
            }
        ],
        [
            {
                r: 127,
                g: 127,
                b: 127
            }
        ],
        [
            {
                r: 111,
                g: 111,
                b: 111
            }
        ],
        [
            {
                r: 95,
                g: 95,
                b: 95
            }
        ],
        [
            {
                r: 79,
                g: 79,
                b: 79
            }
        ],
        [
            {
                r: 63,
                g: 63,
                b: 63
            }
        ],
        [
            {
                r: 47,
                g: 47,
                b: 47
            }
        ],
        [
            {
                r: 31,
                g: 31,
                b: 31
            }
        ],
        [
            {
                r: 15,
                g: 15,
                b: 15
            }
        ],
        [
            {
                r: 0,
                g: 0,
                b: 0
            }
        ]
    ],
    "material": [
        [
            {
                r: 244,
                g: 67,
                b: 54
            }
        ],
        [
            {
                r: 233,
                g: 30,
                b: 99
            }
        ],
        [
            {
                r: 156,
                g: 39,
                b: 176
            }
        ],
        [
            {
                r: 103,
                g: 58,
                b: 183
            }
        ],
        [
            {
                r: 63,
                g: 81,
                b: 181
            }
        ],
        [
            {
                r: 33,
                g: 150,
                b: 243
            }
        ],
        [
            {
                r: 33,
                g: 169,
                b: 244
            }
        ],
        [
            {
                r: 0,
                g: 188,
                b: 212
            }
        ],
        [
            {
                r: 0,
                g: 150,
                b: 136
            }
        ],
        [
            {
                r: 76,
                g: 175,
                b: 80
            }
        ],
        [
            {
                r: 139,
                g: 195,
                b: 74
            }
        ],
        [
            {
                r: 205,
                g: 220,
                b: 57
            }
        ],
        [
            {
                r: 255,
                g: 235,
                b: 59
            }
        ],
        [
            {
                r: 255,
                g: 193,
                b: 7
            }
        ],
        [
            {
                r: 255,
                g: 152,
                b: 0
            }
        ],
        [
            {
                r: 255,
                g: 87,
                b: 34
            }
        ],
        [
            {
                r: 121,
                g: 85,
                b: 72
            }
        ],
        [
            {
                r: 158,
                g: 158,
                b: 158
            }
        ],
        [
            {
                r: 96,
                g: 125,
                b: 139
            }
        ]
    ],
    "ios7": [
        [
            {
                r: 255,
                g: 94,
                b: 58
            },
            {
                r: 255,
                g: 42,
                b: 104
            }
        ],
        [
            {
                r: 255,
                g: 149,
                b: 0
            },
            {
                r: 255,
                g: 94,
                b: 58
            }
        ],
        [
            {
                r: 255,
                g: 219,
                b: 76
            },
            {
                r: 255,
                g: 205,
                b: 2
            }
        ],
        [
            {
                r: 135,
                g: 252,
                b: 112
            },
            {
                r: 11,
                g: 211,
                b: 24
            }
        ],
        [
            {
                r: 82,
                g: 237,
                b: 199
            },
            {
                r: 90,
                g: 200,
                b: 251
            }
        ],
        [
            {
                r: 26,
                g: 214,
                b: 253
            },
            {
                r: 29,
                g: 98,
                b: 240
            }
        ],
        [
            {
                r: 198,
                g: 68,
                b: 252
            },
            {
                r: 88,
                g: 86,
                b: 214
            }
        ],
        [
            {
                r: 239,
                g: 77,
                b: 182
            },
            {
                r: 198,
                g: 67,
                b: 252
            }
        ],
        [
            {
                r: 74,
                g: 74,
                b: 74
            },
            {
                r: 43,
                g: 43,
                b: 43
            }
        ],
        [
            {
                r: 219,
                g: 221,
                b: 222
            },
            {
                r: 137,
                g: 140,
                b: 144
            }
        ],
        [
            {
                r: 255,
                g: 59,
                b: 48
            }
        ],
        [
            {
                r: 255,
                g: 149,
                b: 0
            }
        ],
        [
            {
                r: 255,
                g: 204,
                b: 0
            }
        ],
        [
            {
                r: 76,
                g: 217,
                b: 100
            }
        ],
        [
            {
                r: 52,
                g: 170,
                b: 220
            }
        ],
        [
            {
                r: 0,
                g: 122,
                b: 255
            }
        ],
        [
            {
                r: 88,
                g: 86,
                b: 214
            }
        ],
        [
            {
                r: 255,
                g: 45,
                b: 85
            }
        ],
        [
            {
                r: 142,
                g: 142,
                b: 147
            }
        ],
        [
            {
                r: 199,
                g: 199,
                b: 199
            }
        ],
        [
            {
                r: 90,
                g: 212,
                b: 39
            },
            {
                r: 164,
                g: 231,
                b: 134
            }
        ],
        [
            {
                r: 200,
                g: 110,
                b: 223
            },
            {
                r: 228,
                g: 183,
                b: 240
            }
        ],
        [
            {
                r: 209,
                g: 238,
                b: 252
            }
        ],
        [
            {
                r: 224,
                g: 248,
                b: 216
            }
        ],
        [
            {
                r: 251,
                g: 43,
                b: 105
            },
            {
                r: 255,
                g: 91,
                b: 55
            }
        ],
        [
            {
                r: 247,
                g: 247,
                b: 247
            },
            {
                r: 215,
                g: 215,
                b: 215
            }
        ],
        [
            {
                r: 29,
                g: 119,
                b: 239
            },
            {
                r: 129,
                g: 243,
                b: 253
            }
        ],
        [
            {
                r: 214,
                g: 206,
                b: 195
            },
            {
                r: 228,
                g: 221,
                b: 202
            }
        ],
        [
            {
                r: 85,
                g: 239,
                b: 203
            },
            {
                r: 91,
                g: 202,
                b: 255
            }
        ],
        [
            {
                r: 255,
                g: 73,
                b: 129
            }
        ],
        [
            {
                r: 255,
                g: 211,
                b: 224
            }
        ],
        [
            {
                r: 247,
                g: 247,
                b: 247
            }
        ],
        [
            {
                r: 255,
                g: 19,
                b: 0
            }
        ],
        [
            {
                r: 31,
                g: 31,
                b: 33
            }
        ],
        [
            {
                r: 189,
                g: 190,
                b: 194
            }
        ],
        [
            {
                r: 255,
                g: 58,
                b: 45
            }
        ]
    ],
    "default": [
        [
            {
                r: 255,
                g: 94,
                b: 58
            },
            {
                r: 255,
                g: 42,
                b: 104
            }
        ],
        [
            {
                r: 76,
                g: 217,
                b: 100
            }
        ],
        [
            {
                r: 255,
                g: 149,
                b: 0
            },
            {
                r: 255,
                g: 94,
                b: 58
            }
        ]
    ]
};
